/* eslint-disable import/no-cycle */
import React, {
  lazy, Suspense, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';

import CannotAccess from '../../../CannotAccess';
import {
  verifyReceivedInboxAccess,
  verifyReferralManagementAccess,
} from '../../../../global/featureFlags';

const InboxRedesignPage = lazy(() => import('./RedesignPage'));

// The redesigned Inbox is now the only Inbox: the `inbox_redesign` flag that used to
// switch it against the legacy ReceivedRecords page was removed (ENG-3557). This
// component stays as the route's access gate — the Received inbox and the referral
// inbox (`?referrals=true`) are guarded by different permissions — and always renders
// the redesign once access is confirmed.
const InboxRedesignGate = (props) => {
  const [hasReceivedInboxAccess, setHasReceivedInboxAccess] = useState(null);
  const locationSearch = (props.location && props.location.search) || window.location.search;

  useEffect(() => {
    let isMounted = true;
    const urlParams = new URLSearchParams(locationSearch);
    const viewingReferralInbox = urlParams.get('referrals') === 'true';
    const verifyInboxAccess = viewingReferralInbox
      ? verifyReferralManagementAccess
      : verifyReceivedInboxAccess;

    (async () => {
      try {
        const hasInboxAccess = await verifyInboxAccess();
        if (isMounted) setHasReceivedInboxAccess(hasInboxAccess === true);
      } catch {
        if (isMounted) setHasReceivedInboxAccess(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [locationSearch]);

  if (hasReceivedInboxAccess === null) return <div>Loading...</div>;
  if (!hasReceivedInboxAccess) return <CannotAccess />;

  return (
    <Suspense fallback={null}>
      {React.createElement(InboxRedesignPage, props)}
    </Suspense>
  );
};

InboxRedesignGate.defaultProps = {
  location: {},
};

InboxRedesignGate.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default InboxRedesignGate;
